export * from './register-guest-resident.request';
